var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "nav-menu" },
    [
      _vm._l(_vm.menuItems, function(item, id) {
        return [
          id === "sponsorship"
            ? _c("div", {
                key: "divider-" + id,
                staticClass: "nav-menu__divider"
              })
            : _vm._e(),
          _vm._v(" "),
          id === "notif" && _vm.hasNotification
            ? [
                _c(
                  "li",
                  {
                    key: id,
                    staticClass: "nav-menu__actions--item",
                    attrs: { id: "headermenu_" + id }
                  },
                  [_c("Notifications")],
                  1
                )
              ]
            : [
                _c(
                  "CompassTooltip",
                  {
                    key: id,
                    staticClass: "nav-item__actions",
                    attrs: {
                      content: item.txt,
                      placement: "bottom",
                      delay: { show: 1000, hide: 0 },
                      arrow: false,
                      disabled: item.id === "add"
                    }
                  },
                  [
                    _c(
                      "li",
                      {
                        key: id,
                        staticClass: "nav-menu__actions--item",
                        class: {
                          "nav-item__actions--item-icon--animated":
                            item.id === "sponsorship"
                        },
                        attrs: { id: "headermenu_" + id }
                      },
                      [_c("NavItem", { attrs: { item: item } })],
                      1
                    )
                  ]
                )
              ]
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }